import { AxiosError } from 'axios';

import { apiV1PostMePinnedTwins } from '../api';

class ChatPinner {
  async pin(slug: string, userId: string): Promise<void> {
    apiV1PostMePinnedTwins({
      slug,
    })
      .then(() => {
        console.info(
          `Chat with slug ${slug} pinned by user ${userId} successfully.`,
        );
      })
      .catch((error) => {
        if (error instanceof AxiosError) {
          console.error(`Failed to pin chat: ${error.message}`);
        } else {
          console.error(
            `An error occurred while pinning the chat: ${
              error.message || JSON.stringify(error)
            }`,
          );
        }
      });
  }
}

export const chatPinner = new ChatPinner();
